"use client";
import { useEffect } from "react";
import Loading from "../components/loading";
import { USER } from "../data/globalVariables";
import PageRoot from "./pageRoot";
import { allPermissions } from "../data/permissions";

export default function Home() {
  const user = USER.useSubscribe(`homeUser`);
  useEffect(() => {
    if (user?.role?.id) {
      const permissionInfo =
        allPermissions[user.role.initialPage || "profilePage"];
      window.location.href = permissionInfo?.href || "/profile";
    }
  }, [user?.role?.id, user?.role?.initialPage]);

  return (
    <PageRoot>
      <div className="center p20">
        <Loading color="red"></Loading>
      </div>
    </PageRoot>
  );
}
